// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"ernestdefoe-calendar:forum/components/CalendarPage":"forum/components/CalendarPage","ernestdefoe-calendar:forum/components/EventDetailModal":"forum/components/EventDetailModal","ernestdefoe-calendar:forum/components/EventFormModal":"forum/components/EventFormModal"}[chunkId] + ".js";
};